import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "section", "indicator", "indicatorLabel"]

  connect() {
    // First button is always the "All" pill
    this.allButton = this.buttonTargets[0]
    if(this.allButton) {
      this.setActiveButton(this.allButton)
    }
  }

  showAll() {
    this.sectionTargets.forEach((section) => {
      section.classList.remove("hidden")
    })
    this.setActiveButton(this.allButton)
    this.indicatorTarget.classList.add("hidden")
  }

  filter(event) {
    const category = event.currentTarget.dataset.category

    this.sectionTargets.forEach((section) => {
      section.classList.toggle("hidden", section.dataset.category !== category)
    })

    this.setActiveButton(event.currentTarget)
    this.indicatorLabelTarget.textContent = category
    this.indicatorTarget.classList.remove("hidden")

    // Scroll the "Zeige:" indicator into view so the user isn't
    // left staring at empty space where hidden sections were.
    this.indicatorTarget.scrollIntoView({ behavior: "smooth", block: "nearest" })
  }

  setActiveButton(activeBtn) {
    const activeClasses = this.data.get("active-class").split(" ")
    const inactiveClasses = this.data.get("inactive-class").split(" ")

    this.buttonTargets.forEach((btn) => {
      btn.classList.remove(...activeClasses)
      btn.classList.add(...inactiveClasses)
    })

    activeBtn.classList.remove(...inactiveClasses)
    activeBtn.classList.add(...activeClasses)
  }
}